export default {
    resalesLanding: {
        sentOn: "Skickat den",
        toggleContact: "Visa/dölj mäklarens kontaktuppgifter",
        propertyOffers: "Bostadserbjudanden",
        openGallery: "Öppna bildgalleri",
        prevPhoto: "Föregående bild",
        nextPhoto: "Nästa bild",
        close: "Stäng",
        photo: "Bild",
        description: "Beskrivning",
        more: "Mer",
        less: "Mindre",
        intFloorSpace: "Boyta",
        build: "Byggyta",
        terrace: "Terrass",
        garden: "Trädgård",
        buildYear: "Byggår",
        fees: "Avgifter",
        communityFees: "Gemensamma avgifter",
        basuraTax: "Renhållningsavgift (Basura)",
        ibiFees: "IBI (fastighetsskatt)",
        securityDeposit: "Deposition",
        perMonth: "/månad",
        perWeek: "/vecka",
        disclaimer: "Friskrivning",
        energyCertificate: "Energideklaration",
        pending: "Väntar",
        rating: "Klassificering",
        presentedBy: "Presenteras av",
        propertyDetails: "Bostadsuppgifter",
        reference: "Referens",
        referenceShort: "Ref",
        unitUnavailable: "Inte längre tillgänglig",
        availableUnits: "Lediga enheter och priser",
        availableUnitsShort: "Lediga enheter",
        unit: "Enhet",
        type: "Typ",
        floors: "Våningar",
        bedrooms: "Sovrum",
        bathrooms: "Badrum",
        surfaceArea: "Invändigt",
        price: "Pris",
        status: "Status",
        unitAvailable: "Ledig",
        unitReserved: "Reserverad",
        unitSold: "Såld",
        seeMore: "Visa mer",
        seeLess: "Visa mindre",
        floor: "Våning",
        storeys: "Antal våningar",
        keyReady: "Inflyttningsklar",
        touristLicence: "Turistlicens",
        firstOccupationLicence: "Slutbesked",
        notKnown: "Ej angivet",
        notProvided: "Uppgift saknas",
        yes: "Ja",
        no: "Nej",
        mortgageAvailable: "Finansiering möjlig",
        guaranteedRental: "Garanterad uthyrning",
        sellBeforeCompletion: "Överlåtelse av avtalet före färdigställande",
        sellBeforeCompletionYes: "Tillåten",
        sellBeforeCompletionNo: "Inte tillåten",
        sellBeforeCompletionNotProvided: "Ej angivet",
        reservation: "Reservation",
        contract: "Kontrakt",
        construction: "Byggnation",
        completion: "Färdigställande",
        co2: "CO2",
        energyConsumption: "Energiförbrukning",
        co2PerYear: "kg CO2/år",
        kwhPerYear: "kWh/år",
        features: "Faciliteter",
        viewDetails: "Visa detaljer",
        hideDetails: "Dölj bostadsuppgifter",
        backToResults: "Resultat",
        viewProperty: "Visa fastighet",
        prevProperty: "Föregående",
        nextProperty: "Nästa",
        viewAllFeatures: "Visa alla faciliteter",
        allFeatures: "Alla faciliteter",
        infoOnRequest: "Information på begäran",
        tbc: "Ej angivet",
        featureCategoryLabels: { pool: "Pool", views: "Utsikt", parking: "Parkering", kitchen: "Kök", condition: "Skick", garden: "Trädgård" },
        featureQualifierFormat: "{value} {category}",
        location: "Läge",
        agencyInformation: "Information om mäklaren",
        buyingCosts: "Köpkostnader",
        propertyPrice: "Bostadspris:",
        priceNote: "**Priset inkluderar inte skatter eller köpkostnader.",
        estimatedPurchaseCosts: "Beräknade köpkostnader:",
        hide: "Dölj",
        showBreakdown: "Visa specifikation av köpkostnader",
        purchaseCostBreakdown: "Specifikation av köpkostnader",
        concept: "Post",
        application: "Beräkning",
        rowTransferTax: "ITP (överlåtelseskatt, befintlig bostad)",
        rowVat: "Moms (nyproduktion)",
        rowVatLand: "Moms",
        vatApplication: "10 % (4 % för subventionerat boende)",
        rowStampDuty: "Stämpelskatt (AJD)",
        rowNotary: "Notarie",
        rowLandRegistry: "Fastighetsregister",
        officialTariff: "Officiell taxa",
        costRangeNotePrefix: "*Köparens totala kostnader ligger vanligtvis mellan",
        and: "och",
        ofPurchasePrice: "av köpeskillingen.",
        costApproxNote: "*De uppskattade köpkostnaderna är endast vägledande. De faktiska kostnaderna kan variera beroende på fastigheten och köparens omständigheter. Vi rekommenderar att du inhämtar professionell rådgivning för en exakt beräkning.",
        additionalInformation: "Ytterligare information",
        addInfoDocument: "*Förkortat informationsdokument tillgängligt i enlighet med det andalusiska dekretet 218/2005",
        addInfoNoFees: "*Köparen betalar inget mäklararvode",
        formHeading: "Vill du veta mer om priserna och bostaden?",
        firstName: "Förnamn",
        enterNumber: "Ange nummer",
        email: "E-post",
        searchCountry: "Sök land eller landskod",
        noMatches: "Inga träffar",
        consent: "Genom att klicka på knappen samtycker du till behandlingen av dina personuppgifter i enlighet med integritetspolicyn, inklusive insamling, lagring och användning av de lämnade uppgifterna för att kontakta dig och ge dig nödvändig information.",
        send: "Skicka",
        contactUs: "Kontakta oss",
        yourMessage: "Ditt meddelande",
        agreeData: "Jag samtycker till att lämna mina uppgifter för att få svar på min informationsförfrågan.",
        agreeContact: "Jag begär att bli informerad och samtycker till att bli kontaktad av det företag som ansvarar för projektet eller berörd återförsäljare, via de kontaktuppgifter som jag frivilligt lämnar för detta ändamål.",
        reject: "Avvisa",
        like: "Gilla",
        liked: "Sparad",
        rejected: "Avvisad",
        offerRejected: "Erbjudande avvisat",
        contact: "Kontakt",
        call: "Ring",
        calling: "Ringer",
        noPhone: "Inget telefonnummer tillgängligt",
        enquirySent: "Förfrågan skickad — vi kontaktar",
        yourDetails: "dina uppgifter",
        respondedTo: "besvarade",
        noProperties: "Inga bostäder att visa.",
        soldOutBody: "Fastigheterna i det här erbjudandet har sålts eller finns inte längre på marknaden. Kontakta byrån för ett uppdaterat urval.",
        expiredTitle: "Den här erbjudandelänken har upphört att gälla",
        expiredBody: "Kontakta mäklaren för en uppdaterad länk för att se dessa bostäder.",
        unavailableTitle: "Erbjudandet är inte tillgängligt",
        unavailableBody: "Vi kunde inte ladda det här erbjudandet. Länken kan vara ogiltig eller tjänsten tillfälligt otillgänglig — försök igen senare eller kontakta mäklaren.",
    },
    title: "{agencyName} s egenskaper",
    in: "in",
    propertiesFound: "fastigheter hittades",
    toDay: "Idag",
    days: "dagar",
    week: "Vecka",
    year: "År",
    month: "Månad",
    prev: "Prev",
    next: "Nästa",
    backToList: "Tillbaka till listan",
    sorry: "Sorry , we",
    cantFind: "kan inte hitta",
    lookingFor: "sidan du letar efter ..",
    thankYou: "TACK FÖR ATT DU BESÖKER VÅR WEBBPLATS",
    pleaseContact: "Kontakta agenten för en ny webbadress.",
    ForSale: "SALE",
    ShortTermRental: "Short Rent",
    LongTermRental: "Long Rent",
    showMore: "Visa mer",
    showLess: "Visa mindre",
    price: "Pris",
    pricePer: "Pris per",
    built: "Bygg",
    floorSpace: "Användbara",
    terrace: "Terrass",
    garden: "Trädgård",
    plot: "tomt",
    propTitle: '{subType} {searchType} in {location}',
    propTitleShort: '{subType} in {location}',
    notAvailable: "Ej tillgängligt",
    notFound: 'Sidan hittades inte',
    emptyProperties: "No properties were found, please contact your Agent for more information.",
    linkExpired: "Oj, den här länken har gått ut. Kontakta din mäklare för att få en uppdaterad fastighetslänk.",
    newDevelopment: "Ny utveckling",
    agencyRaiiNo: "Byråns registreringsnummer",
    home: {
        verifyYourURLHere: "Verifiera din URL här. För att göra detta, logga in på WhatsApp i din webbläsare och kopiera sedan URL-adressen från WhatsApp till här.",
        pasteUrlHere: "Klistra in URL här",
        verifyUrl: "Verifiera URL",
        whatIsPropertyViewer: "Vad är Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Denna webbplats används av fastighetsmäklare för att skicka fastigheter till sina kunder. Den är en produkt från {resalesonlinecom} Om du är osäker, vänligen tala med agenten som skickade din fastighetslista till dig.",
        howDoesItWork: "Hur fungerar det?",
        inThePast: "Tidigare skulle agenter skicka PDF-dokument till sina kunder. Dessa är dock inte lätta att visa på många enheter. Därför har vi {propertyviewercom} så att klienten lättare kan visa egenskaper som skickas till dem.",
        createAShortList: "Agenten kommer att skapa en kort lista med egenskaper. När de delar dessa egenskaper med dig får du en länk. Om du klickar på den här länken visas egenskaperna."
    },

    list: {
        propertyTitle: "Klicka här om du vill visa information för den här egenskapen"
    },

    searchType: {
        ForSale: "till salu",
        ShortTermRental: "för korttidsuthyrning",
        LongTermRental: "för långtidsuthyrning",
    },

    rsStatus: {
        Available: "Tillgänglig",
        Listing: "Lista",
        UnderOffer: "Under Erbjudande",
        SaleAgreed: "Försäljning överenskommen",
        OffMarket: "Utanför marknaden",
        Sold: "Såld",
        Rented: "Hyrd"
    },

    details: {
        average: "Genomsnitt",
        averagePricesFor: "Genomsnittspriser för",
        showFullER: "Visa hela",
        thisProperty: "Denna fastighet",
        infoNotAvailable: "Denna information är inte tillgänglig.",
        feesEnergyRating: "Avgifter, energiklass",
        fees: "Avgifter",
        ibiFees: "IBI-avgifter",
        basuraTax: "Basura Tax",
        communityFees: "Community Fees",
        associatedCosts: "Tillhörande kostnader",
        energyRating: "Energi betyg",
        securityDeposit: "Deposition",
        energyCertificate: "Energy certificate",
        energyCertificatePending: "Energicertifikatet väntar",
        energyConsumption: "Energiförbrukning",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² per år",
        kwhPerYear: "kWh/m² per år",
        other: "Andra",
        buildYear: "Byggår",
        forSale: "Till salu",
        sold: "Såld",
        longTerm: "Long term",
        shortTermHigh: "Short term high",
        shortTermLow: "Kort sikt låg",
        allFeatures: "Alla funktioner",
        aproxLocation: "Aprox. Location",
        listingAgent: "Listing agent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Turistregistreringsnummer",
        agencyInformation: "Information från byrån",
    },
};